import React from 'react'
import format from 'date-fns/format'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

const DateMarker = ({date, large}: {date: string; large?: boolean}) => {
  return (
    <Box sx={{display: 'flex'}}>
      <CalendarMonthIcon fontSize="small" sx={{mr: 1}}></CalendarMonthIcon>
      <Typography
        variant={large ? 'body1' : 'caption'}
        sx={{display: 'inline'}}
      >
        {format(Date.parse(date), 'MMM dd, yyyy').toUpperCase()}
      </Typography>
    </Box>
  )
}

export default DateMarker
